module.exports = {
    header: {
        dashboard: '仪表盘',
        write: '撰写',
        draft: '草稿',
        manage: '管理',
        article: '文章',
        manageArticles: '文章',
        keepAlive: '页面缓存',
        login: '登录页',
        logout: '退出登录',
        setting: '设置',
        comment: '评论',
        tag: '标签',
        classification: '分类',
        user: '用户',
        link: '友情链接',
        file: '文件',
        theme: '博客主题',
        ppt: '首页轮播图',
    },
    files: {
        title: '文件',
        btn: '上传 Excel 文件'
    }

};
